import { memo, useContext, useEffect, useMemo, useState } from "react";
import EnumsContext from "context/initialize-context";
import FormGenerator from "components/form-generator/main/main";
import { arrayToRecursiveInTree } from "utils/recursive";

const Form = props => {
    const {
        id,
        formId,
        mode,
        setParentLoading,
        goSubmit,
        defaultValues,
        draftLabel,
        defaultCats,
        doneCallback = () => { },
        targetCategory,
        groupType
    } = props;

    const enumsData = useContext(EnumsContext);
    const [categories, setCategories] = useState([]);
    const [formElements, setFormElements] = useState([]);
    const [fields, setFields] = useState([]);

    const activeIds = useMemo(() => {
        if (groupType === 2)
            return enumsData.permissions.forms_group_policies[formId].elemets_exclude_group_template;

        return null;
        // eslint-disable-next-line
    }, [groupType])

    useEffect(() => {
        if (!enumsData.loading && !enumsData.error) {
            // set fields
            const newFields = [];

            enumsData.data.formElements.forEach(field => {
                if (field.form_id === parseInt(formId)) {
                    newFields.push({
                        ...field,
                        name: `e${field.id}_${field.name}`
                    });
                }
            });

            setFields(newFields);

            const recursive = arrayToRecursiveInTree(enumsData.data.categories);
            setCategories(recursive);

            setFormElements(enumsData.data.formElements);
        }

        // eslint-disable-next-line
    }, [enumsData])

    const preData = {
        form_id: parseInt(formId),
        status_id: 1
    }

    if (id)
        preData.id = id;

    return (
        <FormGenerator
            fields={fields}
            submitUrl={`/api/content/${mode}`}
            goSubmit={goSubmit}
            setParentLoading={setParentLoading}
            payloadType={3}
            defaultValues={defaultValues}
            draftLabel={draftLabel}
            submitMethod={mode === "edit" ? "PUT" : "POST"}
            preData={preData}
            doneCallback={doneCallback}
            categoryModule={true}
            categories={categories}
            categoriesFields={formElements}
            defaultSelectedCategories={defaultCats}
            targetCategory={targetCategory}
            activeIds={activeIds}
        />
    )
}

export default memo(Form);